import Vue from 'vue'
import Router from 'vue-router'

import index from '@/pages/index'
import loan from '@/pages/loan' //借贷
import loanProceeds from '@/pages/loanProceeds'//借贷收益
import user from '@/pages/user'

import duihuang from '@/pages/duihuang' //兑换

import safety from '@/pages/safety' //安全中心
import setCashPwd from '@/pages/setCashPwd' //设置提现密码
import onlineService from '@/pages/onlineService' //在线客服

import invitation from '@/pages/invitation' //我的邀请

import myOrder from '@/pages/myOrder' //我的订单
import myOrderDetail from '@/pages/myOrderDetail' //我的订单详情
import capitalDetails from '@/pages/capitalDetails' //资金明细

import pay from '@/pages/pay' //购买中心

import deposit from '@/pages/deposit' //充币
import cbjl from '@/pages/cbjl' //充币记录
import tbjl from '@/pages/tbjl' //提币记录

import txcg from '@/pages/txcg' //提现成功
import withdraw from '@/pages/withdraw' //提币
import lang from '@/pages/lang' //语言
import selectBz from '@/pages/selectBz' //币种选择
import selectCbBz from '@/pages/selectCbBz' //充币币种选择

import downLoad from '@/pages/downLoad' // 下载

import loading from '@/components/loading' //加载动画

import sign from '@/pages/sign' //签到
import rule from '@/pages/rule' //签到规则
import activityRule from '@/pages/activityRule' //赚币规则

import transaction from '@/pages/transaction' //币币交易
import kline from '@/pages/kline' //K线

import selectDay from '@/pages/selectDay' //选择天数

import share from '@/pages/share'

import emailBind from '@/pages/emailBind' //邮箱绑定
import shareReward from '@/pages/shareReward' //分享收益
import nodeAuth from '@/pages/nodeAuth' //节点认证

import subscription from '@/pages/subscription' //新币申购
import subscribe from '@/pages/subscribe' //新币申购订阅
import subscriptionList from '@/pages/subscriptionList' //新币申购列表

import contractTransaction from '@/pages/contractTransaction' //交割合约
import positionList from '@/pages/positionList' //交割记录
import accountRecords from '@/pages/accountRecords' //交割记录
import myAssets from '@/pages/myAssets' //资产记录
import setWithdrawPwd from '@/pages/setWithdrawPwd' //设置交易密码
import currency from '@/pages/currency' //借币
import currencyRecord from '@/pages/currencyRecord' //借币记录
import repayment from '@/pages/repayment' //借币还款
import repayment2 from '@/pages/repayment2' //借币还款
import agreement from '@/pages/agreement' //借币协议
import notice from '@/pages/notice'//公告
import benefits from '@/pages/benefits' //福利专区
import benefitsDetail from '@/pages/benefitsDetail' //福利专区
import about from '@/pages/about' //关于我们
import privacyPolicy from '@/pages/privacyPolicy' //隐私政策
import compliance from '@/pages/compliance' //合规性
import credit from '@/pages/credit'//信用分
import c2c from '@/pages/c2c'//c2c
import c2cCreate from '@/pages/c2cCreate'//c2cCreate
import c2cOrder from '@/pages/c2cOrder'//c2cOrder
import currencyTrading from '@/pages/currencyTrading'//currencyTrading
import loanBuy from '@/pages/loanBuy' //持币购买
import orderStatus from '@/pages/orderStatus' //持币订单
import c2cCredentials from '@/pages/c2cCredentials' //C2C提交凭证
import videos from '@/pages/videos' //视频
import preciousMetal from '@/pages/preciousMetal' //贵金属
import trading from '@/pages/trading' //贵金属交易大厅
import contractOrder from '@/pages/contractOrder' //贵金属订单
import setProfit from '@/pages/setProfit' //贵金属设置止盈止损
import contractTransaction2 from '@/pages/contractTransaction2' //贵金属交割
import positionList2 from '@/pages/positionList2' //贵金属交割列表
import metalTrading from '@/pages/metalTrading' //贵金属交易
import bannerDetail from '@/pages/bannerDetail' //bannerDetail
import taxSubsidies from '@/pages/taxSubsidies' //税收补贴

Vue.use(Router)

export default new Router({
  linkActiveClass:'active',
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: '',
      component: index,
      // meta: {
      //   // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      // }
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      // meta: {
      //   requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      // }
    },
    {
      path: '/loan',
      name: '借贷',
      component: loan,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/loanProceeds',
      name: '借贷收益',
      component: loanProceeds
    },
    {
      path: '/user',
      name: '我的',
      component: user,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/duihuang',
      name: '兑换',
      component: duihuang
    },
    {
      path: '/safety',
      name: '安全中心',
      component: safety,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/emailBind',
      name: '邮箱绑定',
      component: emailBind,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/onlineService',
      name: '在线客服',
      component: onlineService,
    },
    {
      path: '/invitation/:code',
      name: 'invitation',
      component: invitation
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      component: myOrder,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/myOrderDetail/:id',
      name: 'myOrderDetail',
      component: myOrderDetail,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/capitalDetails',
      name: 'capitalDetails',
      component: capitalDetails,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: withdraw,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/pay',
      name: 'pay',
      component: pay,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/loading',
      name: '加载动画',
      component: loading
    },
    {
      path: '/setCashPwd',
      name: 'setCashPwd',
      component: setCashPwd
    },
    {
      path: '/deposit',
      name: 'deposit',
      component: deposit
    },
    {
      path: '/cbjl',
      name: 'cbjl',
      component: cbjl
    },
    {
      path: '/tbjl',
      name: 'tbjl',
      component: tbjl
    },
    {
      path: '/txcg',
      name: 'txcg',
      component: txcg
    },
    {
      path: '/lang',
      name: 'lang',
      component: lang
    },
    {
      path: '/selectBz',
      name: 'selectBz',
      component: selectBz
    },
    {
      path: '/selectCbBz',
      name: 'selectCbBz',
      component: selectCbBz
    },
    {
      path: '/downLoad',
      name: 'downLoad',
      component: downLoad
    },
    {
      path: '/sign',
      name: 'sign',
      component: sign
    },
    {
      path: '/rule',
      name: 'rule',
      component: rule
    },
    {
      path: '/activityRule',
      name: 'activityRule',
      component: activityRule
    },
    {
      path: '/transaction',
      name: 'transaction',
      component: transaction,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/kline',
      name: 'kline',
      component: kline,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/selectDay',
      name: 'selectDay',
      component: selectDay
    },
    {
      path: '/share',
      name: '分享',
      component: share,
    },
    {
      path:'/',
      redirect:'index'
    },
    {
      path: '/shareReward',
      name: '分享收益',
      component: shareReward,
    },
    {
      path: '/nodeAuth',
      name: '节点认证',
      component: nodeAuth,
      meta: {
        // requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/subscription',
      name: '新币申购',
      component: subscription,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/subscribe',
      name: '新币申购订阅',
      component: subscribe,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/subscriptionList',
      name: '新币申购列表',
      component: subscriptionList,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/contractTransaction',
      name: '交割合约',
      component: contractTransaction,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/positionList',
      name: '交割记录',
      component: positionList,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/accountRecords',
      name: '账户记录',
      component: accountRecords,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/myAssets',
      name: '资产记录',
      component: myAssets,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/setWithdrawPwd',
      name: '交易密码',
      component: setWithdrawPwd,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/currency',
      name: 'currency',
      component: currency,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/currencyRecord',
      name: 'currencyRecord',
      component: currencyRecord,
      meta: {
        requireAuth: true,  // 添加该字段，表示进入这个路由是需要登录的
      }
    },
    {
      path: '/repayment',
      name: 'repayment',
      component: repayment,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/repayment2',
      name: 'repayment2',
      component: repayment2,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/agreement',
      name: 'agreement',
      component: agreement,
    },
    {
      path: '/notice',
      name: 'notice',
      component: notice,
    },
    {
      path: '/benefits',
      name: 'benefits',
      component: benefits,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/benefitsDetail',
      name: 'benefitsDetail',
      component: benefitsDetail,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/about',
      name: 'about',
      component: about,
    },
    {
      path: '/privacyPolicy',
      name: 'privacyPolicy',
      component: privacyPolicy,
    },
    {
      path: '/compliance',
      name: 'compliance',
      component: compliance,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/credit',
      name: 'credit',
      component: credit,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/c2c',
      name: 'c2c',
      component: c2c,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/c2cCreate',
      name: 'c2cCreate',
      component: c2cCreate,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/c2cOrder',
      name: 'c2cOrder',
      component: c2cOrder,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/currencyTrading',
      name: 'currencyTrading',
      component: currencyTrading,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/loanBuy',
      name: 'loanBuy',
      component: loanBuy,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/orderStatus',
      name: 'orderStatus',
      component: orderStatus,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/c2cCredentials',
      name: 'c2cCredentials',
      component: c2cCredentials,
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/videos',
      name: 'videos',
      component: videos,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/preciousMetal',
      name: 'preciousMetal',
      component: resolve =>(require(["@/pages/preciousMetal"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/trading',
      name: 'trading',
      component: resolve =>(require(["@/pages/trading"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractOrder',
      name: 'contractOrder',
      component: resolve =>(require(["@/pages/contractOrder"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/setProfit',
      name: 'setProfit',
      component: resolve =>(require(["@/pages/setProfit"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/contractTransaction2',
      name: 'contractTransaction2',
      component: resolve =>(require(["@/pages/contractTransaction2"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/positionList2',
      name: 'positionList2',
      component: resolve =>(require(["@/pages/positionList2"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/metalTrading',
      name: 'metalTrading',
      component: resolve =>(require(["@/pages/metalTrading"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/bannerDetail',
      name: 'bannerDetail',
      component: resolve =>(require(["@/pages/bannerDetail"],resolve)),
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/selectAiBz',
      name: 'selectAiBz',
      component: resolve =>(require(["@/pages/selectAiBz"],resolve)),
      meta: {
        requireAuth: true
      }
    },
    {
      path: '/taxSubsidies',
      name: 'taxSubsidies',
      component: resolve =>(require(["@/pages/taxSubsidies"],resolve)),
      meta: {
        requireAuth: true
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js